<script lang="ts">
  // externals
  import { params } from "@roxi/routify";

  // components
  import LimitedOrderingProducts from "@retailer/svelte/LimitedOrderingProductRequests/Index.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";

  // services
  import { getGroupRetailers } from "@retailer/services/limited_ordering_product_requests_service";

  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  const discoveryPanelRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: "/api/retailer/discovery_panel/discovery_config",
        data: { page_name: "product_approvals", page_value: null },
      });
      return res;
    } catch (e) {
      return [];
    }
  };

  async function load() {
    const discoveryPanelConfig = await discoveryPanelRes();

    const getGroupRetailersRes = await getGroupRetailers();

    const results = await Promise.all([discoveryPanelConfig, getGroupRetailersRes]);

    return {
      discoveryPanel: results[0],
    };
  }
</script>

{#await load()}
  <Spinner />
{:then data}
  <LimitedOrderingProducts discoveryPanelConfig={data.discoveryPanel} />
{/await}
